import React from 'react';
import { Card, CardBody, CardTitle, Col, Container, Row } from 'reactstrap';
import Breadcrumb from 'Components/Common/Breadcrumb';

const UgMainSource = () => {
  document.title = "Ус хангамжийн эх үүсвэрийн эрүүл ахуйн бүс, тэжээгдлийн мужийн зааг";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Газрын доорх ус" breadcrumbItem="Ус хангамжийн эх үүсвэрийн эрүүл ахуйн бүс, тэжээгдлийн мужийн зааг" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <CardTitle tag="h5" className="mb-0 flex-grow-1">Ус хангамжийн эх үүсвэрийн эрүүл ахуйн бүс, тэжээгдлийн мужийн зааг</CardTitle>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment >
  );
}

export default UgMainSource;